module.exports = __webpack_public_path__ + "img/login_img400.522b3a03.jpg";